import styled from 'styled-components';

export const StyledUl = styled.ul`
	position: relative;
	border: 1px solid #A6FF79;
	padding: 8px;
	list-style-type: none;
	margin-block-start: 0;
	white-space: nowrap;

	&.dragging {
		background-color: black;
		border-color: transparent;

		> * {
			visibility: hidden;
		}
	}
`;

export const StyledLi = styled.li`
	display: flex;
	align-items: center;
`;

export const StyledLabel = styled.label`
	color: #A6FF79;
`;

export const StyledInput = styled.input`
	margin: 4px 4px 4px 8px !important;
	padding: 0 0 0 4px !important;
	background: black !important;
	color: white !important;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const StyledSelect = styled.select`
	margin: 4px 4px 4px 8px !important;
	background: black !important;
	color: white !important;
`;

export const StyledButton = styled.button`
	padding: 8px !important;
	margin: 0 !important;
`;

export const StyledSmallButton = styled.button`
	padding: 0px 4px !important;
	margin: 0 0 0 8px !important;
	font-size: 9px;
`;

export const StyledSpan = styled.span`
	margin: 0 0 0 8px !important;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const OpenButton = styled.button`
	position: absolute;
	top: -8px;
	right: -8px;
	margin: 0 !important;
	padding: 8px;
	color: black;
	z-index: 1;
`;

export const HeaderContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 16px;
`;

export const ConfigurationUl = styled.ul`
	display: flex;
	flex-direction: column;
	width: 100%;
	border: 1px solid gray;
	padding: 4px;
	margin: 0;
	background-color: black;
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: space-between;
	height: 46px;
`;
